import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { AccordionGroupSelectedState } from './types';
export default function AccordionGroup({ groupName, itemNames, selectedItems, groupSelectedState, expanded, toggleAccordionVisibility, toggleGroup, toggleItem, }) {
    return (React.createElement(Accordion, { expanded: expanded, disableGutters: true, "data-testid": `accordion-select-section`, sx: {
            '&:before': {
                display: 'none',
            },
        } },
        React.createElement(AccordionSummary, { onClick: () => toggleAccordionVisibility() },
            React.createElement(Stack, { width: "100%", direction: "row", justifyContent: "space-between", alignItems: "center" },
                React.createElement(FormControl, { key: groupName },
                    React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { onClick: (e) => e.stopPropagation(), checked: groupSelectedState === AccordionGroupSelectedState.All, indeterminate: groupSelectedState === AccordionGroupSelectedState.Some, onChange: toggleGroup }), label: React.createElement(Typography, { fontWeight: "fontWeightBold" }, groupName) })))),
        React.createElement(Stack, { m: 0, ml: "48px", gap: 1.5 }, itemNames.map((item) => {
            return (React.createElement(FormControl, { key: item, "data-testid": `item-${item}` },
                React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: selectedItems.includes(`${groupName}|${item}`), onChange: () => {
                            const itemWithGroup = `${groupName}|${item}`;
                            toggleItem(itemWithGroup);
                        } }), label: React.createElement(Typography, null, item) })));
        }))));
}
